// src/components/layout/Footer.jsx
import React from 'react';

const Footer = () => {
    const footerLinks = [
        { title: 'Platform', links: ['Markets', 'Trade', 'Portfolio', 'Status'] },
        { title: 'Resources', links: ['Documentation', 'API Access', 'FAQs', 'Support'] },
        { title: 'Company', links: ['About Us', 'Careers', 'Blog', 'Security'] },
        { title: 'Legal', links: ['Terms of Use', 'Privacy Policy', 'Risk Disclosure'] },
    ];

    return (
        <footer>
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-column">
                        <a href="#" className="logo" style={{ marginBottom: '20px' }}>
                            <i className="fas fa-chart-line"></i>
                            Kinetix
                        </a>
                        <p style={{ color: 'var(--text-secondary)' }}>Advanced derivatives trading built on Solana.</p>
                        <div className="social-links">
                            <a href="#"><i className="fab fa-twitter"></i></a>
                            <a href="#"><i className="fab fa-discord"></i></a>
                            <a href="#"><i className="fab fa-telegram-plane"></i></a>
                        </div>
                    </div>
                    {footerLinks.map((col) => (
                        <div key={col.title} className="footer-column">
                            <h3>{col.title}</h3>
                            <ul className="footer-links">
                                {col.links.map((link) => (
                                    <li key={link}><a href="#">{link}</a></li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className="footer-bottom">
                    &copy; {new Date().getFullYear()} Kinetix. All rights reserved. Trading carries significant risk.
                </div>
            </div>
        </footer>
    );
};

export default Footer;